import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Stay-Tune-Subscription_imageColumn'
import themeBase from './_themeBase'
import INDEX from './_index'
import _cloneDeep from 'lodash/cloneDeep'

const info =  _cloneDeep(baseInfo)
const json =  _cloneDeep(baseJson)
const templateID = info.templateID + INDEX

info.templateID = templateID
info.priority = 10
// info.name = 'Black Friday:' + info.name
json.templateID = templateID
json.theme =  _cloneDeep(themeBase.theme)

const colorPalette = {
  white: '#fcf7dc',
  black: '#161a1e',
  customColor: '#1e431a',
}

// Override primary and secondary colors
json.theme.headline.color = colorPalette.customColor // White for headlines
json.theme.text.color = colorPalette.customColor // #e39b85 for general text
json.theme.button.backgroundColor = colorPalette.customColor // #e39b85 for button backgrounds
json.theme.button.color = colorPalette.white // White text on buttons
json.theme.button.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.voucher.color = colorPalette.white // White text for vouchers
json.theme.voucher.borderColor = colorPalette.customColor // #e39b85 border for vouchers
json.theme.field.color = colorPalette.customColor // #e39b85 for field text
json.theme.field.borderColor = colorPalette.customColor // #e39b85 borders for fields
json.theme.survey.color = colorPalette.customColor // #e39b85 for survey text
json.theme.survey.borderColor = colorPalette.customColor // #e39b85 borders for survey
json.theme.wheel.color = colorPalette.black // White text on the wheel
json.theme.wheel.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.wheel.backgroundColor = colorPalette.customColor
json.theme.wheel.secondaryBackgroundColor = colorPalette.white
json.theme.checkbox.color = colorPalette.white // #e39b85 for checkbox tick
json.theme.checkbox.borderColor = colorPalette.customColor // #e39b85 borders for checkboxes
json.theme.checkbox.checkboxColor = colorPalette.customColor // #e39b85 background for checkboxes
json.theme.social.color = colorPalette.customColor // #e39b85 for social icons

json.settings = {
  ...json.settings,
  // closeButtonColor: '#FEFEFE',
}

json.settings = {
  ...json.settings,
  closeButtonColor: '#1e431a',
  sideImage: {
    ...json.settings.sideImage,
    content: {
      ...(json.settings.sideImage?.content ?? {}),
      url: 'https://assets.onvocado.com/templates/christmas-1.png',
    },
  },
}

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#fcf7dc',
  backgroundImage: '',
}
// Modify content items as needed
// json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
//   if (item.type === 'headline') {
//     item.content.text = 'Black Friday Specials Await!'
//     item.styling.fontSize = '40px'
//   }
//   return item
// })

export { json, info }